export function section03() {
    gsap.from(".section#section-3 .stat .number", {
        textContent: 0,
        duration: 2,
        ease: "Power2.easeOut",
        snap: { textContent: 1 },
        stagger: {
            each: 0.25,
            onUpdate: function () {
                this.targets()[0].innerHTML = numberWithCommas(
                    Math.ceil(this.targets()[0].textContent)
                )
            },
        },
        scrollTrigger: {
            trigger: ".section#section-3",
            start: "center bottom",
            end: "center 30%",
            scrub: 1,
        },
    })
}
